<template>
  <div>
    <b-row>
      <b-col xl="9" lg="12" order-xl="1" order-lg="2" order-md="2" order-sm="2" order="2" >
        <div v-for="(post, id) in cms" v-bind:key="id" class="card m-auto post" style="max-width: 600px;">
          <div class="card-body pt-3 pb-0">
            <b-row>
              <b-col xl="1" class="p-0">
                <b-img left style="width:100%;" :src="`${post.owner.pathAvatar}?tr=w-500,h-530,fo-auto/tr:r-max`" shape="circle" fluid alt="Fluid image"></b-img>
              </b-col>
              <b-col>
                <div class="mb-2 pt-2">
                  <b class="font-size-15">{{  post.owner.fullName  }}</b> · {{ moment(post.createdAt).format('DD-MMM-YYYY') }}
                </div>
                <div>
                  <p
                    class="text-dark font-weight-bold m-0"
                  >{{post.title}}</p>
                </div>
                <div class="ql-editor p-0" style="min-height: auto; height: auto; overflow: hidden;">
                    <div v-if="post.description != ''" v-html="viewFrame(post.description)"></div>
                    <p>
                      {{ simplifyText(post.description , 1) }}
                      <a v-if="simplifyText(post.description, 2)" @click="previewModal(post.id)" class="text-dark font-weight-bold text-underline-hover">Ver mas</a>
                    </p>
                  </div>
                  <div v-show="post.categories.length > 0" class="my-1">
                  <p v-for="(category, id) in post.categories" v-bind:key="id"
                    class="badge text-blue text-uppercase bg-light font-size-12 mr-2"
                  >{{ category.name }}</p>
                </div>
                <img v-show="post.pathBanner !== '' && post.pathBanner !== null" :src="post.pathBanner" alt="..." style="margin: auto; display: block; max-width: 100%;"><br/>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-if="loading" class="card text-center mt-2 m-auto" style="max-width: 600px; height: 4em; border: 0;">
          <div class="card-body pt-3 pb-0">
            <b-row>
              <b-col>
                <b-spinner label="Spinning"/>
              </b-col>
            </b-row>
          </div>
        </div>
        <infinityScroll @intersect="intersected"/>
      </b-col>
      <!-- Componente para la barra -->
      <b-col v-show="maxCms > 0" xl="3" lg="12" order-xl="2" order-lg="1" order-md="1" order-sm="1" order="1">
        <div class="pb-1 mb-1">
          <label class="font-weight-bold d-block" for="search-input">
            <span class="mb-2 d-inline-block">Buscar Post</span>
            <b-input id="input-search" ref="search" v-model="searchPost" description="Busca por titulo o descripción" placeholder="Buscar..."></b-input>
          </label>
        </div>
        <!-- <div class="pb-4 mb-3 border-bottom">
          <div class="font-weight-bold mb-2">Tags</div>
          <div>
            <b-button :pressed="checkButton(category)" @click="addTag(category)" v-for="(category, id) in categories" v-bind:key="id"
              variant="secondary" class="badge text-blue font-size-12 mr-2"
            >{{category.name}}</b-button>
          </div>
        </div> -->
      </b-col>
    </b-row>
    <b-modal id="preview" ref="modal" size="lg" :title="'Post #'+ preview.id" hide-footer>
      <div class="card-body pt-3 pb-0">
        <b-row>
          <b-col xl="1" class="p-0">
            <b-img left style="width:100%;" :src="`${preview.owner.pathAvatar}?tr=w-500,h-530,fo-auto/tr:r-max`" shape="circle" fluid alt="Fluid image"></b-img>
          </b-col>
          <b-col>
            <div class="mb-2 pt-2">
              <a class="font-weight-bold" href="javascript: void(0);">{{preview.owner.fullName}}</a>· {{ moment(preview.createdAt).format('DD-MMM-YYYY') }}
            </div>
            <div>
              <h5
                class="text-dark font-weight-bold mb-2"
              >{{preview.title}}</h5>
            </div>
            <div class="ql-editor p-0" style="min-height: auto; height: auto; overflow: hidden;">
                {{ simplifyText(preview.description, 3) }}
                <div v-html="viewFrame(preview.description)"></div>
            </div>
            <div v-show="preview.categories.length > 0" class="mb-1 mt-3">
              <a v-for="(category, id) in preview.categories" v-bind:key="id"
                href="javascript: void(0);"
                class="badge text-blue text-uppercase bg-light font-size-12 mr-2"
              >{{ category.name }}</a>
            </div>
            <img v-show="preview.pathBanner !== '' && preview.pathBanner !== null" :src="preview.pathBanner" alt="..." style="margin: auto; display: block; max-width: 100%;"><br/>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<style>
.text-underline-hover {
    text-decoration: none;
}

.text-underline-hover:hover {
    text-decoration: underline;
}
.post:nth-child(n + 2){
  margin-top: 17px !important;
}
</style>
<script>
import { mapState } from 'vuex'
import apiClient from '@/services/axios'
import axios from 'axios'
import moment from 'moment'
import infinityScroll from '@/components/custom/infinityScroll'
// import { hasRole } from '@/services/utilities'
// import Swal from 'sweetalert2'
import { consts, showErrorMessage } from '@/services/utilities'
import store from 'store'

export default {
  name: 'cmsDashboard',
  components: {
    infinityScroll,
  },
  data() {
    return {
      moment,
      maxCms: 0,
      loading: true,
      typingTimer: '',
      page: {
        number: 1,
        requested: false,
      },
      selectedTags: [],
      preview: {
        id: '',
        title: '',
        description: '',
        categories: [],
        owner: {},
        pathBanner: '',
      },
      searchPost: '',
      error: '',
      cms: [],
      categories: [],
      consts,
    }
  },
  beforeRouteEnter (to, from, next) {
    function getCategories() {
      return apiClient.get('/products/categories?type=2')
    }

    function getCms() {
      return apiClient.get('/cms?page=0&perpage=6&state=true')
    }
    const userStorage = JSON.parse(store.get('userData'))
    if (userStorage.role !== consts.rolesText.SU) {
      axios.all([getCategories(), getCms()])
        .then(axios.spread(function (categories, cms) {
          next((vm) => {
            vm.setDataCategories(null, categories.data)
            vm.setDataCms(null, cms.data)
          })
        }))
        .catch(err => {
          next((vm) => {
            vm.setDataCategories(err, [])
            vm.setDataCms(err, [])
          })
        })
    } else next()
  },
  methods: {
    previewModal(id) {
      apiClient.get(`/cms/${id}`).then(response => {
        this.preview = response.data
        this.$bvModal.show('preview')
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    simplifyText(text, type) {
      let beforeTag = ''
      const start = text.indexOf('&lt;')
      const end = text.lastIndexOf('&gt;')
      const frame = text.substring(start, end + 4)
      const cleanText = text.split(frame).join('')
      let description = cleanText.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>|<!--.*?-->|&nbsp;/gi, (match, tag) => {
        if (tag === 'br') {
          if (beforeTag === '/p') {
            beforeTag = tag
            return '' // Don't remove line breaks
          } else {
            beforeTag = tag
            return '\n'
          }
        } else if (match === '&nbsp;') {
          beforeTag = tag
          return ' ' // Replace &nbsp; with a space
        } else if (tag === '/p') {
          beforeTag = tag
          return '\n' // Remove everything else
        } else {
          beforeTag = tag
          return '' // Remove everything else
        }
      })
      if (type === 3) {
        return description
      } else if (type === 1) {
        if (description.length > 150) {
          description = description.substr(0, 150)
          return description + '...'
        }
        return description
      } else {
        return (description.length > 150)
      }
    },
    async intersected() {
      if (!this.loading) {
        this.loading = true
        if (!this.page.requested) {
          await apiClient.get(`/cms?page=${this.page.number}&perpage=6&state=true&search=${this.searchPost}&tags=${this.selectedTags}`).then(response => {
            if (response.data.results.rows.length > 0) {
              this.page.number++
              this.cms = [...this.cms, ...response.data.results.rows]
            } else {
              this.page.requested = true
            }
          })
        }
        this.loading = false
      }
    },
    setDataCms (err, data, onCall = false) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.cms = data.results.rows
        if (!onCall) {
          this.maxCms = data.results.totalPosts
        }
        this.loading = false
      }
    },
    debounce() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    search() {
      this.loading = true
      let q = ''
      if (this.searchPost) {
        q += '&search=' + this.searchPost
      }
      if (this.selectedTags.length > 0) {
        q += '&tags=[' + this.selectedTags + ']'
      }
      apiClient.get(`/cms?page=0&perpage=6&state=true${q}`).then(response => {
        this.setDataCms(null, response.data, true)
      })
    },
    addTag(category) {
      if (!this.selectedTags.includes(category.id)) {
        this.selectedTags.push(category.id)
      } else {
        this.selectedTags = this.selectedTags.filter(item => item !== category.id)
      }
      this.search()
    },
    checkButton(category) {
      return this.selectedTags.includes(category.id)
    },
    setDataCategories (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.categories = data
      }
    },
    // Convert to lowercase(including special characters)
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    viewFrame: function(text) {
      const start = text.indexOf('&lt;')
      const end = text.lastIndexOf('&gt;')
      const frame = text.substring(start, end + 4)
      return frame.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    },
  },
  watch: {
    searchPost: function () {
      this.debounce()
    },
  },
  /* Filtra los productos del input */
  computed: {
    ...mapState(['user']),
  },
  created: function() {
  },
}

</script>
